import React, { useState, useEffect, useContext } from 'react';
import { NotificationContext } from '../../context/NotificationContext';
import api from '../../api';

const LocationManager = ({ configId }) => {
  const { showNotification } = useContext(NotificationContext);
  const [locations, setLocations] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone_number: '',
    operating_hours: '',
    address: ''
  });

  useEffect(() => {
    loadLocations();
  }, [configId]);

  const loadLocations = async () => {
    try {
      const response = await api.get(`/admin/locations/${configId}`);
      setLocations(response.data);
    } catch (error) {
      showNotification('Error loading locations: ' + error.message, true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const submissionData = {
        configuration_id: parseInt(configId),
        name: formData.name,
        phone_number: formData.phone_number || undefined,
        operating_hours: formData.operating_hours || undefined,
        address: formData.address || undefined
      };

      await api.post('/admin/locations/', submissionData);
      showNotification('Location added successfully!');
      setIsModalOpen(false);
      setFormData({
        name: '',
        phone_number: '',
        operating_hours: '',
        address: ''
      });
      loadLocations();
    } catch (error) {
      showNotification('Failed to add location: ' + error.message, true);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this location?')) return;

    try {
      await api.delete(`/admin/locations/${id}`);
      showNotification('Location deleted successfully!');
      loadLocations();
    } catch (error) {
      showNotification('Failed to delete location: ' + error.message, true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="section-card">
      <div className="section-header">
        <h2>Locations</h2>
        <button 
          className="add-entity-btn"
          onClick={() => setIsModalOpen(true)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd"/>
          </svg>
          <span>Add Location</span>
        </button>
      </div>
      
      <div className="section-content">
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Operating Hours</th>
                <th>Address</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {locations.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center py-4 text-gray-500">
                    No locations found.
                  </td>
                </tr>
              ) : (
                locations.map(location => (
                  <tr key={location.id}>
                    <td>{location.name}</td>
                    <td>{location.phone_number || '-'}</td>
                    <td>{location.operating_hours || '-'}</td>
                    <td>{location.address || '-'}</td>
                    <td>
                      <button 
                        onClick={() => handleDelete(location.id)}
                        className="text-red-600 hover:text-red-800 font-medium"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && (
        <div className="section-modal">
          <button 
            className="modal-close"
            onClick={() => setIsModalOpen(false)}
          >
            ×
          </button>
          <h3>Add Location</h3>
          <form onSubmit={handleSubmit}>
            <div>
              <label className="form-label">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="form-input"
                required
              />
            </div>
            <div>
              <label className="form-label">Phone</label>
              <input
                type="tel"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleInputChange}
                className="form-input"
              />
            </div>
            <div>
              <label className="form-label">Operating Hours</label>
              <input
                type="text"
                name="operating_hours"
                value={formData.operating_hours}
                onChange={handleInputChange}
                className="form-input"
              />
            </div>
            <div>
              <label className="form-label">Address</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                className="form-input"
              />
            </div>
            <div className="modal-actions">
              <button type="button" onClick={() => setIsModalOpen(false)}>
                Cancel
              </button>
              <button type="submit" disabled={loading}>
                {loading ? 'Adding...' : 'Add Location'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default LocationManager; 